import { useCallback } from "react";
import { useMutation , useQueryClient } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { BaseDataService } from "src/apis/services/baseData/baseDataService";
import { SettingDto } from "src/data/models/settingDtos/settingDto.interface";

import { container } from "tsyringe";

export const useEditSetting = () => {
    const settingService = container.resolve(BaseDataService);
    const queryClient = useQueryClient();
    const toggleEditSetting = useCallback(
        (data, variables, context) => {
            let tempData = queryClient.getQueryData<SettingDto>([Api.BaseData.getSetting]);
            tempData.aboutUsString = data.aboutUsString;
            tempData.address = data.address;
            tempData.contactUsText = data.contactUsText;
            tempData.email = data.email;
            tempData.footerText = data.footerText;
            tempData.instagram = data.instagram;
            tempData.linkedin = data.linkedin;
            tempData.phone1 = data.phone1;
            tempData.phone2 = data.phone2;
            tempData.projectsText = data.projectsText;
            tempData.slogan = data.slogan;
            tempData.standardsText = data.standardsText;
            tempData.telegram = data.telegram;
            tempData.twitter = data.twitter;
            tempData.whatsApp = data.whatsApp;
            tempData.settingId = data.settingId;
            queryClient.setQueryData([Api.BaseData.getSetting],tempData )
        },
        [],
    );
    return useMutation({
        mutationFn: (data: SettingDto) => {
            return settingService.editSetting(data);
        },
        onSuccess: toggleEditSetting
    })

}
